var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"room socket-record"},[_vm._v("\n  Socket记录\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }